import styled, { css } from "styled-components";
import { Checkbox } from "antd";
import { RATypography } from "../Typography";
import { noop } from "lodash";

export const RACheckbox = ({ title = "", onChange = noop, checked, numRows = 1, "data-testid": dataTestId = null }) => (
	<CustomCheckbox
		onChange={onChange}
		checked={checked}
		style={{ display: "flex", flexWrap: "nowrap" }}
		data-testid={dataTestId}
	>
		{!!title && (
			<RATypography variant="body3" color="#595959" maxLines={numRows}>
				{title}
			</RATypography>
		)}
	</CustomCheckbox>
);

const CustomCheckbox = styled(Checkbox)`
	.ant-radio-inner {
		width: 20px;
		height: 20px;

		&::after {
			width: 12px;
			height: 12px;
		}
	}
	.ant-checkbox-inner {
		width: 20px;
		height: 20px;

		&::after {
			width: 8px;
			height: 12px;
		}
	}
	.ant-radio,
	.ant-checkbox {
		font-size: 20px;
	}
	${(props) =>
		props.theme.color_primary_500 &&
		css`
			& .ant-checkbox-checked .ant-checkbox-inner {
				background-color: ${props.theme.color_primary_500};
				border-color: ${props.theme.color_primary_500};
			}
			& .ant-checkbox-wrapper-checked:hover .ant-checkbox-inner,
			.ant-checkbox-checked:hover .ant-checkbox-inner {
				border-color: ${props.theme.color_primary_500} !important;
			}

			& .ant-checkbox-wrapper:hover .ant-checkbox-inner,
			.ant-checkbox:hover .ant-checkbox-inner,
			.ant-checkbox-input:focus + .ant-checkbox-inner {
				border-color: ${props.theme.color_primary_500} !important;
			}
		`}
`;
